import BasePage from './BasePage';
import BodyStateAdapter from '../components/BodyStateAdapter';
import SelectionViewAdapter from '../views/SelectionViewAdapter';
import HiddenMarketsWidget from '../components/HiddenMarketsWidget';

let rendered = false;

export default {
    getContentURL({ locale, sport, path = '' }) {
        return `/betting/${locale}/${sport}/${path}`;
    },

    postReady(deps, content, args) {
        BodyStateAdapter.init(BasePage.jQuery, 'racing', args.sport);
        if (deps.ready) {
            deps.ready('racing');
        }
    },

    postRender() {
        BasePage.setOddsFormat();
        BasePage.switchTab('Racing');
        SelectionViewAdapter.init();
        HiddenMarketsWidget.start();
    },

    bindNavigation() { },

    setRendered() {
        rendered = true;
    },

    setUnrendered() {
        HiddenMarketsWidget.stop();
        rendered = false;
    },

    isRendered() {
        return rendered;
    },

    id: 'racing',
};